import "materialize-css";
import React, { useEffect } from "react";
import {
  Button,
  Row,
  NavItem,
  Navbar,
  Modal,
} from "react-materialize";
import Aos from "aos";
import "aos/dist/aos.css";
import logo from "./svg/LOGO.svg";

const Home = () => {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <Row className="">
      <Navbar
        className="blue darken-3 white-text"
        menuIcon={"kontakt"}
        alignLinks="left"
        brand={
          <div>
            <img
              className="logo"
              alt="Hydraulik Kraków – Bogusław Wnęk"
              width="79%"
              src={logo}
            />
          </div>
        }
        id="mobile-nav"
        options={{
          draggable: true,
          edge: "left",
          inDuration: 250,
          onCloseEnd: null,
          onCloseStart: null,
          onOpenEnd: null,
          onOpenStart: null,
          outDuration: 200,
          preventScrolling: true,
        }}
      >
        <NavItem
          className="orange darken-3 z-depth-5 bold white-text"
          href="tel:+48789807598"
        >
          ☏ tel: 789 807 598
        </NavItem>
        <NavItem
          className="deep-purple darken-4 z-depth-5 bold white-text"
          href="mailto:wnekhydraulika@gmail.com"
        >
          ✉ wnekhydraulika@gmail.com
        </NavItem>
        <NavItem
          className="z-depth-5 green darken-4 bold white-text"
          href="https://maps.app.goo.gl/92m4gkAt5DEow1WCA"
          target="_blank"
          rel="noopener noreferrer"
        >
          ⚐ Google Maps
        </NavItem>
        <NavItem
          className="z-depth-5 blue darken-3 bold white-text"
          href="https://www.facebook.com/Pphpu-El-Gaz-Wod-Trans-100306922667762"
          target="_blank"
          rel="noopener noreferrer"
        >
          Facebook
        </NavItem>
        <NavItem
          className="z-depth-5 green darken-3 bold white-text"
          href="https://api.whatsapp.com/send?phone=+48789807598"
          target="_blank"
          rel="noopener noreferrer"
        >
          WhatsApp
        </NavItem>
        <NavItem>
          <Modal
            actions={[
              <Button flat modal="close" node="button" waves="green">
                Zamknij
              </Button>,
            ]}
            bottomSheet={false}
            fixedFooter={false}
            header="RODO"
            id="Modal-10"
            open={false}
            options={{
              dismissible: true,
              endingTop: "10%",
              inDuration: 250,
              onCloseEnd: null,
              onCloseStart: null,
              onOpenEnd: null,
              onOpenStart: null,
              opacity: 0.5,
              outDuration: 250,
              preventScrolling: true,
              startingTop: "4%",
            }}
            trigger={
              <Button className="blue" node="button">
                RODO
              </Button>
            }
          >
            <p>
              Klauzula informacyjna dla klientów i kontrahentów. Zgodnie z przepisami rozporządzenia
              Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. („RODO")
              informujemy, że administratorem Państwa danych osobowych jest P.P.H.U. EL-GAZ-WOD-TRANZ
              Bogusław Wnęk. Dane przetwarzane są w celu realizacji umów, obsługi zapytań oraz
              wypełnienia obowiązków prawnych (art. 6 ust. 1 lit. a, b, c, f RODO).
              Przysługuje Państwu prawo dostępu, sprostowania, usunięcia danych, ograniczenia
              przetwarzania, sprzeciwu oraz wniesienia skargi do Prezesa UODO.
              Podanie danych jest dobrowolne, lecz niezbędne do zawarcia umowy lub udzielenia odpowiedzi.
            </p>
          </Modal>
        </NavItem>
      </Navbar>
    </Row>
  );
};

export default Home;
